/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BuslineImportEntriesQueryResponse,
  BuslineImportsQueryResponse,
  CreateBuslineImportsCommand,
  ExecuteBuslineImportParams,
  GetBuslineImportEntriesParams,
  GetBuslineImportsParams
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getBuslineImports = (
    params: GetBuslineImportsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<BuslineImportsQueryResponse>(
      {url: `/api/v1/busline/imports`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBuslineImportsQueryKey = (params: GetBuslineImportsParams,) => {
    return [`/api/v1/busline/imports`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBuslineImportsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImports>>, GetBuslineImportsParams['page']>, TError = ErrorType<unknown>>(params: GetBuslineImportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData, Awaited<ReturnType<typeof getBuslineImports>>, QueryKey, GetBuslineImportsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineImportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineImports>>, QueryKey, GetBuslineImportsParams['page']> = ({ signal, pageParam }) => getBuslineImports({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData, Awaited<ReturnType<typeof getBuslineImports>>, QueryKey, GetBuslineImportsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineImportsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineImports>>>
export type GetBuslineImportsInfiniteQueryError = ErrorType<unknown>


export function useGetBuslineImportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImports>>, GetBuslineImportsParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData, Awaited<ReturnType<typeof getBuslineImports>>, QueryKey, GetBuslineImportsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImports>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImports>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImports>>, GetBuslineImportsParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData, Awaited<ReturnType<typeof getBuslineImports>>, QueryKey, GetBuslineImportsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImports>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImports>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImports>>, GetBuslineImportsParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData, Awaited<ReturnType<typeof getBuslineImports>>, QueryKey, GetBuslineImportsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineImportsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImports>>, GetBuslineImportsParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData, Awaited<ReturnType<typeof getBuslineImports>>, QueryKey, GetBuslineImportsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineImportsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineImportsQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(params: GetBuslineImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineImportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineImports>>> = ({ signal }) => getBuslineImports(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineImportsQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineImports>>>
export type GetBuslineImportsQueryError = ErrorType<unknown>


export function useGetBuslineImports<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImports>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImports<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImports>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImports<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineImports<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineImportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineImportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(params: GetBuslineImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineImportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineImports>>> = ({ signal }) => getBuslineImports(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineImportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineImports>>>
export type GetBuslineImportsSuspenseQueryError = ErrorType<unknown>


export function useGetBuslineImportsSuspense<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportsSuspense<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportsSuspense<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineImportsSuspense<TData = Awaited<ReturnType<typeof getBuslineImports>>, TError = ErrorType<unknown>>(
 params: GetBuslineImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImports>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineImportsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createBuslineImports = (
    createBuslineImportsCommand: BodyType<CreateBuslineImportsCommand>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append('file', createBuslineImportsCommand.file)
formData.append('date', createBuslineImportsCommand.date)

      return instance<void>(
      {url: `/api/v1/busline/imports`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getCreateBuslineImportsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBuslineImports>>, TError,{data: BodyType<CreateBuslineImportsCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBuslineImports>>, TError,{data: BodyType<CreateBuslineImportsCommand>}, TContext> => {
    
const mutationKey = ['createBuslineImports'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBuslineImports>>, {data: BodyType<CreateBuslineImportsCommand>}> = (props) => {
          const {data} = props ?? {};

          return  createBuslineImports(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateBuslineImportsMutationResult = NonNullable<Awaited<ReturnType<typeof createBuslineImports>>>
    export type CreateBuslineImportsMutationBody = BodyType<CreateBuslineImportsCommand>
    export type CreateBuslineImportsMutationError = ErrorType<unknown>

    export const useCreateBuslineImports = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBuslineImports>>, TError,{data: BodyType<CreateBuslineImportsCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createBuslineImports>>,
        TError,
        {data: BodyType<CreateBuslineImportsCommand>},
        TContext
      > => {

      const mutationOptions = getCreateBuslineImportsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getBuslineImportEntries = (
    id: number,
    params: GetBuslineImportEntriesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<BuslineImportEntriesQueryResponse>(
      {url: `/api/v1/busline/imports/${id}/entries`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBuslineImportEntriesQueryKey = (id: number,
    params: GetBuslineImportEntriesParams,) => {
    return [`/api/v1/busline/imports/${id}/entries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBuslineImportEntriesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImportEntries>>, GetBuslineImportEntriesParams['page']>, TError = ErrorType<unknown>>(id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData, Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey, GetBuslineImportEntriesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineImportEntriesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey, GetBuslineImportEntriesParams['page']> = ({ signal, pageParam }) => getBuslineImportEntries(id,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData, Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey, GetBuslineImportEntriesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineImportEntriesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineImportEntries>>>
export type GetBuslineImportEntriesInfiniteQueryError = ErrorType<unknown>


export function useGetBuslineImportEntriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImportEntries>>, GetBuslineImportEntriesParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData, Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey, GetBuslineImportEntriesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImportEntries>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportEntriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImportEntries>>, GetBuslineImportEntriesParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData, Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey, GetBuslineImportEntriesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImportEntries>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportEntriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImportEntries>>, GetBuslineImportEntriesParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData, Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey, GetBuslineImportEntriesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineImportEntriesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineImportEntries>>, GetBuslineImportEntriesParams['page']>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData, Awaited<ReturnType<typeof getBuslineImportEntries>>, QueryKey, GetBuslineImportEntriesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineImportEntriesInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineImportEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineImportEntriesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineImportEntries>>> = ({ signal }) => getBuslineImportEntries(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineImportEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineImportEntries>>>
export type GetBuslineImportEntriesQueryError = ErrorType<unknown>


export function useGetBuslineImportEntries<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImportEntries>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImportEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportEntries<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineImportEntries>>,
          TError,
          Awaited<ReturnType<typeof getBuslineImportEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportEntries<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineImportEntries<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineImportEntriesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineImportEntriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineImportEntriesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineImportEntries>>> = ({ signal }) => getBuslineImportEntries(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineImportEntriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineImportEntries>>>
export type GetBuslineImportEntriesSuspenseQueryError = ErrorType<unknown>


export function useGetBuslineImportEntriesSuspense<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportEntriesSuspense<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineImportEntriesSuspense<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineImportEntriesSuspense<TData = Awaited<ReturnType<typeof getBuslineImportEntries>>, TError = ErrorType<unknown>>(
 id: number,
    params: GetBuslineImportEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineImportEntries>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineImportEntriesSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const executeBuslineImport = (
    id: number,
    params?: ExecuteBuslineImportParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<void>(
      {url: `/api/v1/busline/imports/execute/${id}`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getExecuteBuslineImportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeBuslineImport>>, TError,{id: number;params?: ExecuteBuslineImportParams}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeBuslineImport>>, TError,{id: number;params?: ExecuteBuslineImportParams}, TContext> => {
    
const mutationKey = ['executeBuslineImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeBuslineImport>>, {id: number;params?: ExecuteBuslineImportParams}> = (props) => {
          const {id,params} = props ?? {};

          return  executeBuslineImport(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteBuslineImportMutationResult = NonNullable<Awaited<ReturnType<typeof executeBuslineImport>>>
    
    export type ExecuteBuslineImportMutationError = ErrorType<unknown>

    export const useExecuteBuslineImport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeBuslineImport>>, TError,{id: number;params?: ExecuteBuslineImportParams}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof executeBuslineImport>>,
        TError,
        {id: number;params?: ExecuteBuslineImportParams},
        TContext
      > => {

      const mutationOptions = getExecuteBuslineImportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const executeTodayBuslineImports = (
    
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<void>(
      {url: `/api/v1/busline/imports/execute-today`, method: 'POST', signal
    },
      options);
    }
  


export const getExecuteTodayBuslineImportsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeTodayBuslineImports>>, TError,void, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeTodayBuslineImports>>, TError,void, TContext> => {
    
const mutationKey = ['executeTodayBuslineImports'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeTodayBuslineImports>>, void> = () => {
          

          return  executeTodayBuslineImports(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExecuteTodayBuslineImportsMutationResult = NonNullable<Awaited<ReturnType<typeof executeTodayBuslineImports>>>
    
    export type ExecuteTodayBuslineImportsMutationError = ErrorType<unknown>

    export const useExecuteTodayBuslineImports = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeTodayBuslineImports>>, TError,void, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof executeTodayBuslineImports>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getExecuteTodayBuslineImportsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    